import { RoleHeader } from "./components/RoleHeader";
import { RoleTable } from "./components/RoleTable";

export const RoleManagement = () => (
  <div>
    <RoleHeader />
    <RoleTable />
  </div>
);
